import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { map, catchError, withLatestFrom, mergeMap } from 'rxjs/operators';
import { BILLING_TRANSACTIONS_REFERENCES_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getBillingTransactionsReferencesRequest,
  getBillingTransactionsReferencesSuccess,
  getBillingTransactionsReferencesFailure,
} from '../actions/billing-transactions-references.actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';
import { IBillingTransactionsReferences } from 'src/app/my-bill/models/billing-transactions-references.model';

@Injectable()
export class BillingTransactionsReferencesEffects {
  getBillingTransactionsReferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getBillingTransactionsReferencesRequest),
      withLatestFrom(this.store.select(selectCustomer)),
      mergeMap(([{ billingAccountNumber }, customer]) =>
        EntityManager.getEntity<IBillingTransactionsReferences>(
          BILLING_TRANSACTIONS_REFERENCES_ENTITY,
          {
            cdbId: customer.customerId,
            paNumber: billingAccountNumber,
          }
        ).pipe(
          map((entity) =>
            entity.value
              ? getBillingTransactionsReferencesSuccess({
                  billingAccountNumber,
                  transactionsReferences: entity.value,
                })
              : getBillingTransactionsReferencesFailure({
                  billingAccountNumber,
                })
          ),
          catchError(() =>
            of(
              getBillingTransactionsReferencesFailure({ billingAccountNumber })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
